import React, { useState } from 'react'
import './index.scss'
import CollectEmailStep from '@Scenes/ForgotPasswordScene/CollectEmailStep'
import ChangePasswordStep from '@Scenes/ForgotPasswordScene/ChangePasswordStep'

const ForgotPasswordScene = () => {
    const [username, setUsername] = useState<string>()

    return (
        <main className="forgot-scene">
            <div className="global-container">
                <div className="forgot-form">
                    {!username ? (
                        <CollectEmailStep setEmailAddress={setUsername} />
                    ) : (
                        <ChangePasswordStep username={username} />
                    )}
                </div>
            </div>
        </main>
    )
}

export default ForgotPasswordScene
